// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1Ss8f","rootSmall":"AddTileButton_rootSmall__2t-Db"};